import '../footer.css';
import React from 'react';

const Footer = () => {
  return (
    <div className="footer">Source code <a href="https://github.com/DevYojan/weatherInfo" target="_new">🔗</a></div>
  );
};

export default Footer;